import { FormikProps, useFormik } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { RootState } from '../../../store/store';
import {
  changePasswordCode,
  clearErrors,
  verifyPassword,
  verifyPasswordFailure,
} from '../../../store/users/users.actions';

type ChangePasswordForm = {
  email: string;
  password: string;
  confirmPassword: string;
  isVerified: boolean;
  errIncorPassword: string;
};

interface ReturnType extends FormikProps<ChangePasswordForm> {
  handleCancel: () => void;
}

export const useChangeUserPassword = (onClose: () => void): ReturnType => {
  const { user } = useSelector((state: RootState) => state.auth);
  const { isPasswordVerified } = useSelector(
    (state: RootState) => state.users.password
  );
  const errors = useSelector((state: RootState) => state.users.errors);
  const dispatch = useDispatch();

  const handleSubmit = (values: ChangePasswordForm) => {
    if (!isPasswordVerified) {
      dispatch(verifyPassword(values.password));
    } else if (
      isPasswordVerified &&
      values.password === values.confirmPassword
    ) {
      dispatch(changePasswordCode(values));
      onClose();
    }
  };

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required('No password provided')
      .min(8, 'Too Short Password!'),
  });

  const formik = useFormik<ChangePasswordForm>({
    initialValues: {
      email: user?.email || '',
      password: '',
      confirmPassword: '',
      isVerified: isPasswordVerified,
      errIncorPassword: errors.verifyPassword,
    },

    onSubmit: handleSubmit,
    validationSchema,
    enableReinitialize: true,
  });

  const handleCancel = () => {
    dispatch(verifyPasswordFailure());
    dispatch(clearErrors());
    formik.resetForm();
    onClose();
  };

  return {
    ...formik,
    handleCancel,
  };
};
